export const MEDICAL_CONDITIONS = [
  {
    label: 'Heart disease',
    value: 'heart_disease'
  },
  {
    label: 'High blood pressure',
    value: 'high_blood_pressure'
  },
  {
    label: 'High cholesterol',
    value: 'high_cholesterol'
  },
  {
    label: 'Type II diabetes',
    value: 'type_ii_diabetes'
  },
  {
    label: 'Sleep apnea',
    value: 'sleep_apnea'
  },
  {
    label: 'High blood sugar',
    value: 'high_blood_sugar'
  },
  {
    label: 'Osteoarthritis of the hips or knees',
    value: 'osteoarthritis_of_the_hips_or_knees'
  },
  {
    label: 'Fatty liver disease',
    value: 'fatty_liver_disease'
  }
];
